import React, { useState, useEffect } from "react";
import { CgProfile } from "react-icons/cg";
import DarkModeToggle from  "./../../components/Common/DarkModeToggle";
import useAuthStore from "./../../stores/authStore";
import { useNavigate } from "react-router-dom";

const ForgotPassword = () => {
    const [email, setEmail] = useState("");
    const navigate = useNavigate();

    const {
        forgotPassword,
        loading,
        error,
        forgotPasswordStatus,
        clearErrors,
        resetForgotPasswordStatus
    } = useAuthStore();

    useEffect(() => {
        // Clear previous errors and status when component mounts
        clearErrors();
        resetForgotPasswordStatus();
    }, [clearErrors, resetForgotPasswordStatus]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        await forgotPassword(email);
    };

    const handleBack = () => {
        navigate("/login");
    };

    return (
        <div className="flex flex-col items-center justify-center min-h-screen bg-gradient-to-b from-white to-[#E0F2F1] dark:from-gray-900 dark:to-gray-800 py-8">
            {/* Dark Mode Toggle */}
            <DarkModeToggle />

            {/* Logo */}
            <div className="mb-16 text-center">
                <img src="/quickcom-logo-text.png" alt="QuickCom" className="h-12 w-auto dark:filter dark:brightness-90" />
            </div>

            {/* Store Illustration */}
            <div className="mb-6 w-72 sm:w-96">
                <img
                    src="/login.png"
                    alt="QuickCom"
                    className="w-full h-auto max-h-90 dark:filter dark:brightness-90"
                />
            </div>

            {forgotPasswordStatus === 'success' ? (
                <div className="text-center w-full max-w-md px-6 sm:px-0">
                    <h2 className="text-xl font-medium text-[#00897B] dark:text-primary-light mb-4">Email envoyé</h2>
                    <p className="text-base text-gray-700 dark:text-gray-300 mb-8">
                        Consultez votre boîte mail pour réinitialiser votre mot de passe.
                    </p>
                    <button
                        onClick={handleBack}
                        className="w-full py-3 bg-[#4DB6AC] dark:bg-primary-dark text-white font-medium rounded-md hover:bg-[#00897B] dark:hover:bg-primary-darker transition-colors duration-200"
                    >
                        Retour à la page de connexion
                    </button>
                </div>
            ) : (
                <>
                    {/* Description */}
                    <p className="text-center text-base font-normal text-gray-700 dark:text-gray-300 mb-8">
                        Saisissez votre adresse email pour<br />
                        réinitialiser votre mot de passe
                    </p>

                    {/* Forgot Password Form */}
                    <form
                        onSubmit={handleSubmit}
                        className="w-full max-w-md px-6 sm:px-0"
                    >
                        {/* Email Input */}
                        <div className="mb-6">
                            <div className="relative">
                                <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 dark:text-gray-500">
                                    <CgProfile className="w-5 h-5" />
                                </div>
                                <input
                                    type="email"
                                    id="email"
                                    name="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Adresse email"
                                    required
                                    className="w-full py-3.5 pl-12 pr-4 border border-gray-200 dark:border-gray-700 rounded-md bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 placeholder-gray-400 dark:placeholder-gray-500 focus:outline-none focus:border-[#4DB6AC] dark:focus:border-primary-light"
                                />
                            </div>
                            {error && (
                                <p className="text-sm text-red-500 dark:text-red-400 mt-1 text-center">
                                    {error}
                                </p>
                            )}
                        </div>

                        {/* Submit Button */}
                        <button
                            type="submit"
                            disabled={loading}
                            className="w-full py-3 bg-[#4DB6AC] dark:bg-primary-dark text-white font-medium rounded-md hover:bg-[#00897B] dark:hover:bg-primary-darker transition-colors duration-200 disabled:opacity-70"
                        >
                            {loading ? "Envoi en cours..." : "Envoyer"}
                        </button>

                        {/* Return Button */}
                        <div className="mt-4 text-center">
                            <button
                                type="button"
                                onClick={handleBack}
                                className="text-[#4DB6AC] dark:text-primary-light text-sm font-medium"
                            >
                                Retour
                            </button>
                        </div>
                    </form>
                </>
            )}
        </div>
    );
};

export default ForgotPassword;
